<template>
  <div class="contact-page">
    <!-- Navigation Bar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
      <div class="container">
        <a class="navbar-brand d-flex align-items-center" href="#home">
          <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="50" class="me-3">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">

          <ul class="navbar-nav ms-auto align-items-center">
            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);" @click="goToPage('/')">Home</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="javascript: void(0);"   @click="goToPage('about')">About</a>
            </li>
            <li class="nav-item d-none">
              <a class="nav-link" href="#how-it-works">How It Works</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#benefits">Benefits</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#services">Health Services</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#enrollment">Enrollment</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#facilities">Health Facilities</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#faqs">FAQs</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contact">Contact</a>
            </li>

            <li class="nav-item dropdown ms-3">
              <button class="btn btn-primary dropdown-toggle" type="button"
                      id="loginDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bx bx-user me-2"></i>Login
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="loginDropdown">
                <li>
                  <a class="dropdown-item" @click="goToMemberLogin">
                    <i class="bx bx-user-circle me-2"></i>Member Portal
                  </a>
                </li>
                <li><hr class="dropdown-divider"></li>
                <li>
                  <a class="dropdown-item" @click="goToStaffLogin">
                    <i class="bx bx-briefcase me-2"></i>Staff Login
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Page Header -->
    <section class="page-header">
      <div class="header-pattern"></div>
      <div class="container">
        <div class="row align-items-center min-vh-40 py-5">
          <div class="col-lg-8 mx-auto text-center text-white position-relative z-2">
            <nav aria-label="breadcrumb" class="mb-4 justify-content-center d-flex">
              <ol class="breadcrumb breadcrumb-light">
                <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Contact Us</li>
              </ol>
            </nav>
            <h1 class="display-3 fw-bold mb-4 animate-on-scroll text-white">
              Get in Touch
            </h1>
            <p class="lead mb-0 animate-on-scroll">
              We're here to help! Contact us through any of the channels below
              for assistance with enrollment, claims, or general inquiries.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Quick Contact Cards -->
    <section class="quick-contact-section">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-3 col-md-6 animate-on-scroll" v-for="contact in quickContacts" :key="contact.title">
            <div class="quick-contact-card h-100" :class="'card-' + contact.color">
              <div class="qc-icon">
                <i :class="contact.icon"></i>
              </div>
              <h5 class="fw-bold mb-2">{{ contact.title }}</h5>
              <p class="text-muted small mb-3">{{ contact.description }}</p>
              <a :href="contact.link" class="qc-value">{{ contact.value }}</a>
              <span class="qc-availability">{{ contact.availability }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Main Contact Section -->
    <section class="py-5 bg-white">
      <div class="container py-5">
        <div class="row g-5">
          <!-- Contact Form -->
          <div class="col-lg-7 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon"><i class="bx bx-envelope"></i></span>
              <span class="label-text">Send Message</span>
            </div>
            <h2 class="display-6 fw-bold mb-4">
              Send Us a
              <span class="text-gradient">Message</span>
            </h2>
            <p class="text-muted mb-4">
              Fill out the form below and we'll get back to you within 24-48 hours.
            </p>

            <form @submit.prevent="submitForm" class="contact-form">
              <div class="row g-4">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Full Name <span class="text-danger">*</span></label>
                    <div class="input-wrapper">
                      <i class="bx bx-user"></i>
                      <input type="text"
                             class="form-control"
                             v-model="form.name"
                             placeholder="Enter your full name"
                             required>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Phone Number <span class="text-danger">*</span></label>
                    <div class="input-wrapper">
                      <i class="bx bx-phone"></i>
                      <input type="tel"
                             class="form-control"
                             v-model="form.phone"
                             placeholder="Enter your phone number"
                             required>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">Email Address</label>
                    <div class="input-wrapper">
                      <i class="bx bx-envelope"></i>
                      <input type="email"
                             class="form-control"
                             v-model="form.email"
                             placeholder="Enter your email (optional)">
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-label">PONA HEALTH-X Member ID</label>
                    <div class="input-wrapper">
                      <i class="bx bx-id-card"></i>
                      <input type="text"
                             class="form-control"
                             v-model="form.memberId"
                             placeholder="Enter if you're a member">
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="form-label">Region / County</label>
                    <div class="input-wrapper">
                      <i class="bx bx-map"></i>
                      <select class="form-control form-select" v-model="form.region">
                        <option value="">Select your region</option>
                        <option v-for="region in regions" :key="region" :value="region">
                          {{ region }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="form-label">Inquiry Type <span class="text-danger">*</span></label>
                    <div class="inquiry-types">
                      <label class="inquiry-type"
                             v-for="type in inquiryTypes"
                             :key="type.value"
                             :class="{ 'active': form.inquiryType === type.value }">
                        <input type="radio"
                               v-model="form.inquiryType"
                               :value="type.value"
                               required>
                        <i :class="type.icon"></i>
                        <span>{{ type.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="form-label">Subject <span class="text-danger">*</span></label>
                    <div class="input-wrapper">
                      <i class="bx bx-edit"></i>
                      <input type="text"
                             class="form-control"
                             v-model="form.subject"
                             placeholder="Brief subject of your inquiry"
                             required>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label class="form-label">Message <span class="text-danger">*</span></label>
                    <div class="input-wrapper textarea-wrapper">
                      <i class="bx bx-message-detail"></i>
                      <textarea class="form-control"
                                v-model="form.message"
                                rows="5"
                                placeholder="Please describe your inquiry in detail..."
                                required></textarea>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button type="submit" class="btn btn-primary btn-lg w-100" :disabled="isSubmitting">
                    <span v-if="!isSubmitting">
                      <i class="bx bx-send me-2"></i>Send Message
                    </span>
                    <span v-else>
                      <span class="spinner-border spinner-border-sm me-2"></span>Sending...
                    </span>
                  </button>
                </div>
              </div>
            </form>

            <!-- Success Message -->
            <div class="success-message animate-on-scroll" v-if="formSubmitted">
              <div class="success-icon">
                <i class="bx bx-check-circle"></i>
              </div>
              <h4 class="fw-bold mb-2">Message Sent Successfully!</h4>
              <p class="text-muted mb-0">
                Thank you for contacting us. We'll respond to your inquiry within 24-48 hours.
              </p>
            </div>
          </div>

          <!-- Contact Info -->
          <div class="col-lg-5 animate-on-scroll">
            <div class="contact-info-card">
              <h4 class="fw-bold mb-4 text-white">Contact Information</h4>

              <div class="info-item">
                <div class="info-icon bg-primary">
                  <i class="bx bx-phone-call"></i>
                </div>
                <div class="info-content">
                  <span class="info-label">Support Hotline</span>
                  <a href="tel:+254700000000" class="info-value">+254 700 000 000</a>
                  <span class="info-note">Available 24/7</span>
                </div>
              </div>

              <div class="info-item">
                <div class="info-icon bg-success">
                  <i class="bx bx-envelope"></i>
                </div>
                <div class="info-content">
                  <span class="info-label">Email Address</span>
                  <a href="mailto:support@ponahealth.com" class="info-value">support@ponahealth.com</a>
                  <span class="info-note">Response within 24-48 hours</span>
                </div>
              </div>

              <div class="info-item">
                <div class="info-icon bg-info">
                  <i class="bx bx-map"></i>
                </div>
                <div class="info-content">
                  <span class="info-label">Head Office</span>
                  <span class="info-value">PONA HEALTH-X Headquarters</span>
                  <span class="info-note">Nairobi, Kenya</span>
                </div>
              </div>

              <div class="info-item">
                <div class="info-icon bg-warning">
                  <i class="bx bx-time"></i>
                </div>
                <div class="info-content">
                  <span class="info-label">Working Hours</span>
                  <span class="info-value">Mon - Fri: 8:00 AM - 5:00 PM</span>
                  <span class="info-note">Hotline available 24/7</span>
                </div>
              </div>

              <!-- Social Media -->
              <div class="social-section">
                <h6 class="fw-bold mb-3">Follow Us</h6>
                <div class="social-links">
                  <a href="#" class="social-link facebook">
                    <i class="bx bxl-facebook"></i>
                  </a>
                  <a href="#" class="social-link twitter">
                    <i class="bx bxl-twitter"></i>
                  </a>
                  <a href="#" class="social-link linkedin">
                    <i class="bx bxl-linkedin"></i>
                  </a>
                  <a href="#" class="social-link youtube">
                    <i class="bx bxl-youtube"></i>
                  </a>
                  <a href="#" class="social-link telegram">
                    <i class="bx bxl-telegram"></i>
                  </a>
                </div>
              </div>

              <!-- Emergency Notice -->
              <div class="emergency-notice">
                <div class="notice-icon">
                  <i class="bx bx-error-circle"></i>
                </div>
                <div class="notice-content">
                  <h6 class="fw-bold mb-1 text-white">Medical Emergency?</h6>
                  <p class="mb-0 small">For medical emergencies, go directly to your nearest health facility. PONA HEALTH-X covers emergency care without referral.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Regional Offices -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-buildings"></i></span>
            <span class="label-text">Offices</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Regional Offices</h2>
          <p class="lead text-muted">Contact your regional office for local PONA HEALTH-X inquiries</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-4 col-md-6 animate-on-scroll" v-for="office in regionalOffices" :key="office.region">
            <div class="office-card h-100">
              <div class="office-header" :style="{ background: office.gradient }">
                <h5 class="fw-bold text-white mb-0">{{ office.region }}</h5>
                <span class="office-type">Regional Office</span>
              </div>
              <div class="office-body">
                <div class="office-info">
                  <div class="oi-item">
                    <i class="bx bx-map"></i>
                    <span>{{ office.city }}</span>
                  </div>
                  <div class="oi-item">
                    <i class="bx bx-phone"></i>
                    <span>{{ office.phone }}</span>
                  </div>
                  <div class="oi-item" v-if="office.email">
                    <i class="bx bx-envelope"></i>
                    <span>{{ office.email }}</span>
                  </div>
                </div>
                <div class="office-stats">
                  <div class="os-item">
                    <span class="os-value">{{ office.subCounties }}</span>
                    <span class="os-label">Sub-Counties</span>
                  </div>
                  <div class="os-item">
                    <span class="os-value">{{ office.facilities }}</span>
                    <span class="os-label">Facilities</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Support Channels -->
    <section class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-support"></i></span>
            <span class="label-text">Support</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">How Can We Help?</h2>
          <p class="lead text-muted">Choose the support channel that works best for you</p>
        </div>

        <div class="row g-4">
          <div class="col-lg-4 animate-on-scroll" v-for="channel in supportChannels" :key="channel.title">
            <div class="support-card h-100">
              <div class="support-icon" :class="'bg-' + channel.color">
                <i :class="channel.icon"></i>
              </div>
              <h4 class="fw-bold mb-3">{{ channel.title }}</h4>
              <p class="text-muted mb-4">{{ channel.description }}</p>
              <ul class="support-features">
                <li v-for="feature in channel.features" :key="feature">
                  <i class="bx bx-check text-success"></i>{{ feature }}
                </li>
              </ul>
              <div class="support-action mt-auto">
                <span class="action-label">{{ channel.actionLabel }}</span>
                <a :href="channel.actionLink" class="action-value">{{ channel.actionValue }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Complaint Process -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-5 mb-lg-0 animate-on-scroll">
            <div class="section-label">
              <span class="label-icon"><i class="bx bx-message-error"></i></span>
              <span class="label-text">Complaints</span>
            </div>
            <h2 class="display-5 fw-bold mb-4">
              Filing a
              <span class="text-gradient">Complaint</span>
            </h2>
            <p class="lead text-muted mb-4">
              We take your feedback seriously. If you have a complaint about PONA HEALTH-X services,
              facilities, or staff, follow these steps:
            </p>

            <div class="complaint-steps">
              <div class="cs-step" v-for="(step, index) in complaintSteps" :key="step.title">
                <div class="cs-number">{{ index + 1 }}</div>
                <div class="cs-content">
                  <h6 class="fw-bold mb-1">{{ step.title }}</h6>
                  <p class="text-muted small mb-0">{{ step.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 animate-on-scroll">
            <div class="complaint-info-card">
              <div class="cic-header">
                <i class="bx bx-shield-check"></i>
                <h5 class="fw-bold mb-0">Your Rights as a Member</h5>
              </div>
              <div class="cic-body">
                <ul class="rights-list">
                  <li><i class="bx bx-check-circle text-success"></i>Right to quality healthcare services</li>
                  <li><i class="bx bx-check-circle text-success"></i>Right to be treated with dignity and respect</li>
                  <li><i class="bx bx-check-circle text-success"></i>Right to file complaints without discrimination</li>
                  <li><i class="bx bx-check-circle text-success"></i>Right to receive timely response to complaints</li>
                  <li><i class="bx bx-check-circle text-success"></i>Right to confidentiality of personal information</li>
                  <li><i class="bx bx-check-circle text-success"></i>Right to appeal decisions you disagree with</li>
                </ul>
                <div class="resolution-time">
                  <i class="bx bx-time-five"></i>
                  <div>
                    <span class="rt-label">Typical Resolution Time</span>
                    <span class="rt-value">7-14 Working Days</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Map Section -->
    <section class="py-5">
      <div class="container py-5">
        <div class="text-center mb-5 animate-on-scroll">
          <div class="section-label justify-content-center">
            <span class="label-icon"><i class="bx bx-map-alt"></i></span>
            <span class="label-text">Location</span>
          </div>
          <h2 class="display-5 fw-bold mb-3">Find Us</h2>
          <p class="lead text-muted">Visit the PONA HEALTH-X headquarters in Nairobi</p>
        </div>

        <div class="map-container animate-on-scroll">
          <div class="map-placeholder">
            <div class="map-overlay">
              <div class="map-info-card">
                <h5 class="fw-bold mb-3">PONA HEALTH-X Headquarters</h5>
                <div class="map-details">
                  <div class="md-item">
                    <i class="bx bx-map"></i>
                    <span>Nairobi, Kenya</span>
                  </div>
                  <div class="md-item">
                    <i class="bx bx-building"></i>
                    <span>Westlands Business District</span>
                  </div>
                  <div class="md-item">
                    <i class="bx bx-time"></i>
                    <span>Mon - Fri: 8:00 AM - 5:00 PM</span>
                  </div>
                </div>
                <a href="https://maps.google.com/?q=Westlands+Nairobi+Kenya"
                   target="_blank"
                   class="btn btn-primary btn-sm mt-3">
                  <i class="bx bx-directions me-2"></i>Get Directions
                </a>
              </div>
            </div>
            <img src="https://images.unsplash.com/photo-1611348524140-53c9a25263d6?w=1200"
                 alt="Map"
                 class="map-image">
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Teaser -->
    <section class="py-5 bg-light">
      <div class="container py-5">
        <div class="faq-teaser animate-on-scroll">
          <div class="row align-items-center">
            <div class="col-lg-8">
              <div class="faq-icon">
                <i class="bx bx-help-circle"></i>
              </div>
              <h3 class="fw-bold mb-2">Have More Questions?</h3>
              <p class="text-muted mb-lg-0">
                Check out our comprehensive FAQ section for answers to common questions about
                PONA HEALTH-X enrollment, coverage, and services.
              </p>
            </div>
            <div class="col-lg-4 text-lg-end">
              <router-link to="/faqs" class="btn btn-primary btn-lg">
                <i class="bx bx-book-open me-2"></i>View FAQs
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-5 bg-gradient-primary text-white">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-8 animate-on-scroll">
            <h2 class="display-5 fw-bold mb-3 text-white">Ready to Join PONA HEALTH-X?</h2>
            <p class="lead mb-4 mb-lg-0 opacity-75">
              Protect your family with affordable healthcare coverage.
              Visit your nearest enrollment center to get started.
            </p>
          </div>
          <div class="col-lg-4 text-lg-end animate-on-scroll">
            <router-link to="/enrollment" class="btn btn-light btn-lg mb-3 me-2">
              <i class="bx bx-user-plus me-2"></i>Enroll Now
            </router-link>
            <a href="tel:+254700000000" class="btn btn-outline-light btn-lg mb-3">
              <i class="bx bx-phone me-2"></i>Call Us
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-5">
      <div class="container">
        <div class="row g-4">
          <div class="col-lg-4">
            <div class="d-flex align-items-center mb-4">
              <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" height="40" class="me-3" style="background: white; padding: 5px; border-radius: 8px;">
              <div>
                <div class="fw-bold">PONA HEALTH-X</div>
                <div class="small text-white-50">Community Health Insurance</div>
              </div>
            </div>
            <p class="text-white-50 mb-4">
              Providing quality healthcare through community-based health insurance.
            </p>
            <div class="footer-social-links">
              <a href="#" class="footer-social-link"><i class="bx bxl-facebook-circle"></i></a>
              <a href="#" class="footer-social-link"><i class="bx bxl-twitter"></i></a>
              <a href="#" class="footer-social-link"><i class="bx bxl-linkedin-square"></i></a>
              <a href="#" class="footer-social-link"><i class="bx bxl-youtube"></i></a>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Quick Links</h6>
            <ul class="footer-links">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/benefits">Benefits</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-6">
            <h6 class="fw-bold mb-3 text-white">Resources</h6>
            <ul class="footer-links">
              <li><router-link to="/facilities">Facilities</router-link></li>
              <li><router-link to="/enrollment">Enrollment</router-link></li>
              <li><router-link to="/faqs">FAQs</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          <div class="col-lg-4">
            <h6 class="fw-bold mb-3 text-white">Contact Us</h6>
            <ul class="footer-contact">
              <li><i class="bx bx-map me-2"></i>Nairobi, Kenya</li>
              <li><i class="bx bx-phone me-2"></i>+254 700 000 000</li>
              <li><i class="bx bx-envelope me-2"></i>support@ponahealth.com</li>
            </ul>
          </div>
        </div>
        <hr class="my-4 opacity-25">
        <div class="row align-items-center">
          <div class="col-md-6 text-center text-md-start">
            <p class="mb-0 text-white-50 small">
              © 2025 PONA HEALTH-X. All rights reserved.
            </p>
          </div>
          <div class="col-md-6 text-center text-md-end">
            <a href="#" class="text-white-50 small text-decoration-none me-3">Privacy Policy</a>
            <a href="#" class="text-white-50 small text-decoration-none">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>

    <!-- Scroll to Top -->
    <button class="scroll-top-btn" @click="scrollToTop" v-show="showScrollTop">
      <i class="bx bx-chevron-up"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PonaHealthContactPage',

  data() {
    return {
      showScrollTop: false,
      isSubmitting: false,
      formSubmitted: false,

      form: {
        name: '',
        phone: '',
        email: '',
        memberId: '',
        region: '',
        inquiryType: '',
        subject: '',
        message: ''
      },

      quickContacts: [
        {
          icon: 'bx bx-phone-call',
          title: 'Call Us',
          description: 'Speak to our support team',
          value: '+254 700 000 000',
          link: 'tel:+254700000000',
          availability: '24/7 Available',
          color: 'primary'
        },
        {
          icon: 'bx bx-envelope',
          title: 'Email Us',
          description: 'Send us your inquiries',
          value: 'support@ponahealth.com',
          link: 'mailto:support@ponahealth.com',
          availability: 'Response in 24-48hrs',
          color: 'success'
        },
        {
          icon: 'bx bx-map',
          title: 'Visit Us',
          description: 'Come to our office',
          value: 'Nairobi, Kenya',
          link: '#location',
          availability: 'Mon-Fri 8:00AM-5:00PM',
          color: 'info'
        },
        {
          icon: 'bx bxl-whatsapp',
          title: 'WhatsApp',
          description: 'Chat with us on WhatsApp',
          value: '+254 700 000 000',
          link: 'https://wa.me/254700000000',
          availability: 'Quick Responses',
          color: 'purple'
        }
      ],

      regions: [
        'Nairobi',
        'Mombasa',
        'Kisumu',
        'Nakuru',
        'Eldoret',
        'Kiambu',
        'Machakos',
        'Kajiado',
        'Nyeri',
        'Meru',
        'Kakamega',
        'Kisii'
      ],

      inquiryTypes: [
        { value: 'enrollment', label: 'Enrollment', icon: 'bx bx-user-plus' },
        { value: 'coverage', label: 'Coverage', icon: 'bx bx-shield-check' },
        { value: 'payment', label: 'Payment', icon: 'bx bx-money' },
        { value: 'complaint', label: 'Complaint', icon: 'bx bx-error-circle' },
        { value: 'facility', label: 'Facility', icon: 'bx bx-hospital' },
        { value: 'other', label: 'Other', icon: 'bx bx-help-circle' }
      ],

      regionalOffices: [
        {
          region: 'Nairobi',
          city: 'Nairobi CBD',
          phone: '+254 700 000 001',
          email: 'nairobi@ponahealth.com',
          subCounties: 17,
          facilities: '450+',
          gradient: 'linear-gradient(135deg, #2c5aa0, #4a90e2)'
        },
        {
          region: 'Coast',
          city: 'Mombasa',
          phone: '+254 700 000 002',
          email: 'coast@ponahealth.com',
          subCounties: 25,
          facilities: '380+',
          gradient: 'linear-gradient(135deg, #28a745, #5cb85c)'
        },
        {
          region: 'Central',
          city: 'Nyeri',
          phone: '+254 700 000 003',
          email: 'central@ponahealth.com',
          subCounties: 35,
          facilities: '520+',
          gradient: 'linear-gradient(135deg, #dc3545, #f1707a)'
        },
        {
          region: 'Western',
          city: 'Kakamega',
          phone: '+254 700 000 004',
          email: 'western@ponahealth.com',
          subCounties: 30,
          facilities: '410+',
          gradient: 'linear-gradient(135deg, #ffc107, #ffda6a)'
        },
        {
          region: 'Rift Valley',
          city: 'Nakuru',
          phone: '+254 700 000 005',
          email: 'riftvalley@ponahealth.com',
          subCounties: 45,
          facilities: '680+',
          gradient: 'linear-gradient(135deg, #17a2b8, #5bc0de)'
        },
        {
          region: 'Nyanza',
          city: 'Kisumu',
          phone: '+254 700 000 006',
          email: 'nyanza@ponahealth.com',
          subCounties: 28,
          facilities: '390+',
          gradient: 'linear-gradient(135deg, #6f42c1, #9d7bd1)'
        },
        {
          region: 'Eastern',
          city: 'Machakos',
          phone: '+254 700 000 007',
          email: 'eastern@ponahealth.com',
          subCounties: 40,
          facilities: '550+',
          gradient: 'linear-gradient(135deg, #fd7e14, #ffb347)'
        },
        {
          region: 'North Eastern',
          city: 'Garissa',
          phone: '+254 700 000 008',
          email: 'northeastern@ponahealth.com',
          subCounties: 15,
          facilities: '180+',
          gradient: 'linear-gradient(135deg, #e83e8c, #f8a5c2)'
        },
        {
          region: 'Upper Eastern',
          city: 'Meru',
          phone: '+254 700 000 009',
          email: 'uppereastern@ponahealth.com',
          subCounties: 22,
          facilities: '340+',
          gradient: 'linear-gradient(135deg, #20c997, #63e6be)'
        }
      ],

      supportChannels: [
        {
          icon: 'bx bx-phone-call',
          title: 'Phone Support',
          description: 'Speak directly with our support team for immediate assistance with your inquiries.',
          color: 'primary',
          features: [
            'Available 24 hours, 7 days a week',
            'Toll-free calling nationwide',
            'Support in English, Swahili, and local languages',
            'Average wait time under 2 minutes'
          ],
          actionLabel: 'Call Now',
          actionValue: '+254 700 000 000',
          actionLink: 'tel:+254700000000'
        },
        {
          icon: 'bx bx-buildings',
          title: 'In-Person Support',
          description: 'Visit your local enrollment center or regional office for face-to-face assistance.',
          color: 'success',
          features: [
            'Personal assistance with enrollment',
            'Document verification on the spot',
            'Card replacement services',
            'Complaint resolution'
          ],
          actionLabel: 'Office Hours',
          actionValue: 'Mon-Fri 8:00-5:00',
          actionLink: '#offices'
        },
        {
          icon: 'bx bx-message-rounded-dots',
          title: 'Digital Support',
          description: 'Reach us through digital channels for convenient, quick responses to your questions.',
          color: 'info',
          features: [
            'Email support with 24-48hr response',
            'WhatsApp chat for quick queries',
            'Member portal for account access',
            'Online complaint submission'
          ],
          actionLabel: 'Email',
          actionValue: 'support@ponahealth.com',
          actionLink: 'mailto:support@ponahealth.com'
        }
      ],

      complaintSteps: [
        {
          title: 'Contact Your Local Office',
          description: 'Start by reporting your complaint to your local PONA HEALTH-X office or the health facility where the issue occurred.'
        },
        {
          title: 'Submit Written Complaint',
          description: 'For formal complaints, submit a written statement describing the issue, including dates, names, and any evidence.'
        },
        {
          title: 'Receive Acknowledgment',
          description: 'You will receive acknowledgment of your complaint within 3 working days with a reference number.'
        },
        {
          title: 'Investigation',
          description: 'Your complaint will be investigated by the appropriate office. You may be contacted for additional information.'
        },
        {
          title: 'Resolution',
          description: 'You will receive a written response with the outcome and any actions taken within 7-14 working days.'
        }
      ]
    };
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.observeElements();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    observeElements() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.observe(el);
      });
    },

    async submitForm() {
      this.isSubmitting = true;

      // Simulate form submission
      await new Promise(resolve => setTimeout(resolve, 2000));

      this.isSubmitting = false;
      this.formSubmitted = true;

      // Reset form
      this.form = {
        name: '',
        phone: '',
        email: '',
        memberId: '',
        region: '',
        inquiryType: '',
        subject: '',
        message: ''
      };

      // Hide success message after 5 seconds
      setTimeout(() => {
        this.formSubmitted = false;
      }, 5000);
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    handleScroll() {
      this.showScrollTop = window.pageYOffset > 300;
    },

    goToMemberLogin() {
      this.$router.push('/member-login');
    },

    goToStaffLogin() {
      this.$router.push('/login');
    },

    goToPage(page) {
      this.$router.push(page);
    },
  }
};
</script>

<style scoped>
/* ========================================================================= */
/* CONTACT PAGE - PROFESSIONAL STYLES */
/* ========================================================================= */

.contact-page {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  background: #fafbfc;
}

/* ========================================================================= */
/* NAVIGATION */
/* ========================================================================= */
.navbar {
  padding: 1rem 0;
  transition: all 0.4s ease;
  z-index: 1001;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
}

.brand-title {
  font-weight: 800;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-subtitle {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 600;
}

.nav-link {
  font-weight: 600;
  color: #495057 !important;
  transition: all 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  color: #2c5aa0 !important;
}

.dropdown-menu {
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 0.5rem;
}

.dropdown-item {
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.dropdown-item:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  transform: translateX(5px);
}

/* ========================================================================= */
/* PAGE HEADER */
/* ========================================================================= */
.page-header {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
  padding-top: 120px;
  padding-bottom: 60px;
  position: relative;
  overflow: hidden;
}

.header-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="60" height="60" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="1" fill="rgba(255,255,255,0.1)"/></svg>');
}

.z-2 {
  z-index: 2;
}

.min-vh-40 {
  min-height: 40vh;
}

.breadcrumb-light {
  background: transparent;
  margin: 0;
  padding: 0;
}

.breadcrumb-light .breadcrumb-item a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
}

.breadcrumb-light .breadcrumb-item a:hover {
  color: white;
}

.breadcrumb-light .breadcrumb-item.active {
  color: white;
}

.breadcrumb-light .breadcrumb-item + .breadcrumb-item::before {
  color: rgba(255, 255, 255, 0.5);
}

/* ========================================================================= */
/* QUICK CONTACT CARDS */
/* ========================================================================= */
.quick-contact-section {
  margin-top: -50px;
  position: relative;
  z-index: 10;
  padding-bottom: 2rem;
}

.quick-contact-card {
  background: white;
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.4s ease;
  border-top: 4px solid transparent;
}

.quick-contact-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 60px rgba(44, 90, 160, 0.2);
}

.card-primary { border-top-color: #2c5aa0; }
.card-success { border-top-color: #28a745; }
.card-info { border-top-color: #17a2b8; }
.card-purple { border-top-color: #6f42c1; }

.qc-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 2rem;
  color: #2c5aa0;
  transition: all 0.3s ease;
}

.card-primary .qc-icon { background: linear-gradient(135deg, #e3f2fd, #bbdefb); color: #2c5aa0; }
.card-success .qc-icon { background: linear-gradient(135deg, #d4edda, #c3e6cb); color: #28a745; }
.card-info .qc-icon { background: linear-gradient(135deg, #d1ecf1, #bee5eb); color: #17a2b8; }
.card-purple .qc-icon { background: linear-gradient(135deg, #e9e3f5, #d4c4ed); color: #6f42c1; }

.quick-contact-card:hover .qc-icon {
  transform: scale(1.1) rotate(10deg);
}

.qc-value {
  display: block;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e3f70;
  text-decoration: none;
  margin-bottom: 0.5rem;
}

.qc-value:hover {
  color: #2c5aa0;
}

.qc-availability {
  display: inline-block;
  background: #f8f9fa;
  padding: 0.35rem 0.75rem;
  border-radius: 50px;
  font-size: 0.75rem;
  color: #28a745;
  font-weight: 600;
}

/* ========================================================================= */
/* SECTION LABELS */
/* ========================================================================= */
.section-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.label-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #2c5aa0;
}

.label-text {
  font-weight: 700;
  font-size: 0.9rem;
  color: #2c5aa0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.text-gradient {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Background colors */
.bg-primary { background: linear-gradient(135deg, #2c5aa0, #4a90e2) !important; }
.bg-success { background: linear-gradient(135deg, #28a745, #5cb85c) !important; }
.bg-warning { background: linear-gradient(135deg, #ffc107, #ffda6a) !important; }
.bg-info { background: linear-gradient(135deg, #17a2b8, #5bc0de) !important; }
.bg-danger { background: linear-gradient(135deg, #dc3545, #f1707a) !important; }
.bg-purple { background: linear-gradient(135deg, #6f42c1, #9d7bd1) !important; }

/* ========================================================================= */
/* CONTACT FORM */
/* ========================================================================= */
.contact-form {
  background: white;
  padding: 2.5rem;
  border-radius: 1.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.form-label {
  font-weight: 600;
  color: #1e3f70;
  margin-bottom: 0.5rem;
}

.input-wrapper {
  position: relative;
}

.input-wrapper i {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 1.25rem;
  z-index: 5;
}

.input-wrapper.textarea-wrapper i {
  top: 1.25rem;
  transform: none;
}

.input-wrapper input,
.input-wrapper select,
.input-wrapper textarea {
  padding-left: 3rem;
  border: 2px solid #e9ecef;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.input-wrapper input:focus,
.input-wrapper select:focus,
.input-wrapper textarea:focus {
  border-color: #2c5aa0;
  box-shadow: 0 0 0 4px rgba(44, 90, 160, 0.1);
}

.form-control {
  padding: 0.875rem 1rem;
}

/* Inquiry Types */
.inquiry-types {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.75rem;
}

.inquiry-type {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border: 2px solid transparent;
  border-radius: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.inquiry-type:hover {
  background: #e3f2fd;
  border-color: #bbdefb;
}

.inquiry-type.active {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-color: #2c5aa0;
}

.inquiry-type input {
  display: none;
}

.inquiry-type i {
  font-size: 1.5rem;
  color: #2c5aa0;
}

.inquiry-type span {
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
}

/* Success Message */
.success-message {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  border-radius: 1.5rem;
  margin-top: 2rem;
}

.success-icon {
  width: 80px;
  height: 80px;
  background: #28a745;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  font-size: 3rem;
  color: white;
}

/* ========================================================================= */
/* CONTACT INFO CARD */
/* ========================================================================= */
.contact-info-card {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
  border-radius: 1.5rem;
  padding: 2.5rem;
  color: white;
  height: 100%;
}

.info-item {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.info-item:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.info-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.info-label {
  display: block;
  font-size: 0.8rem;
  opacity: 0.7;
  margin-bottom: 0.25rem;
}

.info-value {
  display: block;
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
  text-decoration: none;
}

.info-value:hover {
  opacity: 0.9;
}

.info-note {
  display: block;
  font-size: 0.8rem;
  opacity: 0.7;
  margin-top: 0.25rem;
}

/* Social Section */
.social-section {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.social-links {
  display: flex;
  gap: 0.75rem;
}

.social-link {
  width: 45px;
  height: 45px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  transition: all 0.3s ease;
}

.social-link.facebook { background: #1877f2; }
.social-link.twitter { background: #1da1f2; }
.social-link.linkedin { background: #0077b5; }
.social-link.youtube { background: #ff0000; }
.social-link.telegram { background: #0088cc; }

.social-link:hover {
  transform: translateY(-5px) scale(1.1);
}

/* Emergency Notice */
.emergency-notice {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  padding: 1.25rem;
  background: rgba(255, 193, 7, 0.2);
  border-radius: 1rem;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.notice-icon {
  width: 45px;
  height: 45px;
  background: #ffc107;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #1e3f70;
  flex-shrink: 0;
}

/* ========================================================================= */
/* REGIONAL OFFICES */
/* ========================================================================= */
.office-card {
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
}

.office-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
}

.office-header {
  padding: 1.5rem;
}

.office-type {
  display: block;
  font-size: 0.8rem;
  opacity: 0.8;
  color: white;
  margin-top: 0.25rem;
}

.office-body {
  padding: 1.5rem;
}

.office-info {
  margin-bottom: 1.5rem;
}

.oi-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  color: #495057;
}

.oi-item i {
  font-size: 1.25rem;
  color: #2c5aa0;
}

.office-stats {
  display: flex;
  gap: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #f0f0f0;
}

.os-item {
  text-align: center;
}

.os-value {
  display: block;
  font-size: 1.25rem;
  font-weight: 900;
  color: #1e3f70;
}

.os-label {
  font-size: 0.8rem;
  color: #6c757d;
}

/* ========================================================================= */
/* SUPPORT CHANNELS */
/* ========================================================================= */
.support-card {
  background: white;
  border-radius: 1.5rem;
  padding: 2rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
}

.support-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(44, 90, 160, 0.15);
}

.support-icon {
  width: 70px;
  height: 70px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 2rem;
  color: white;
  transition: all 0.3s ease;
}

.support-card:hover .support-icon {
  transform: scale(1.1) rotate(5deg);
}

.support-features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;
}

.support-features li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
  color: #495057;
}

.support-features li i {
  font-size: 1.25rem;
  margin-top: 2px;
}

.support-action {
  padding-top: 1.5rem;
  border-top: 1px solid #f0f0f0;
}

.action-label {
  display: block;
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}

.action-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2c5aa0;
  text-decoration: none;
}

.action-value:hover {
  color: #1e3f70;
}

/* ========================================================================= */
/* COMPLAINT STEPS */
/* ========================================================================= */
.complaint-steps {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cs-step {
  display: flex;
  gap: 1rem;
  padding: 1.25rem;
  background: #f8f9fa;
  border-radius: 1rem;
  transition: all 0.3s ease;
}

.cs-step:hover {
  background: #e3f2fd;
  transform: translateX(10px);
}

.cs-number {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #2c5aa0, #4a90e2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  color: white;
  flex-shrink: 0;
}

/* Complaint Info Card */
.complaint-info-card {
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
}

.cic-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #28a745, #5cb85c);
  color: white;
}

.cic-header i {
  font-size: 2rem;
}

.cic-body {
  padding: 2rem;
}

.rights-list {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;
}

.rights-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.rights-list li:last-child {
  border-bottom: none;
}

.rights-list li i {
  font-size: 1.25rem;
  margin-top: 2px;
}

.resolution-time {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 1rem;
}

.resolution-time i {
  font-size: 2rem;
  color: #2c5aa0;
}

.rt-label {
  display: block;
  font-size: 0.8rem;
  color: #6c757d;
}

.rt-value {
  display: block;
  font-weight: 700;
  color: #1e3f70;
}

/* ========================================================================= */
/* MAP SECTION */
/* ========================================================================= */
.map-container {
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
}

.map-placeholder {
  position: relative;
  height: 400px;
}

.map-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.map-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(30, 63, 112, 0.8), rgba(44, 90, 160, 0.6));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.map-info-card {
  background: white;
  padding: 2rem;
  border-radius: 1.5rem;
  text-align: center;
  max-width: 400px;
}

.map-details {
  text-align: left;
}

.md-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  color: #495057;
}

.md-item i {
  font-size: 1.25rem;
  color: #2c5aa0;
}

/* ========================================================================= */
/* FAQ TEASER */
/* ========================================================================= */
.faq-teaser {
  background: white;
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.faq-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #2c5aa0;
  flex-shrink: 0;
}

/* ========================================================================= */
/* CTA */
/* ========================================================================= */
.bg-gradient-primary {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 50%, #4a90e2 100%);
}

/* ========================================================================= */
/* BUTTONS */
/* ========================================================================= */
.btn {
  padding: 0.875rem 2rem;
  border-radius: 0.75rem;
  font-weight: 700;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.btn-primary {
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  border-color: transparent;
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.btn-light {
  background: white;
  color: #2c5aa0;
}

.btn-outline-light {
  color: white;
  border-color: white;
}

.btn-outline-light:hover {
  background: white;
  color: #2c5aa0;
}

/* ========================================================================= */
/* FOOTER */
/* ========================================================================= */
footer {
  background: linear-gradient(135deg, #1e3f70 0%, #2c5aa0 100%);
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: white;
  padding-left: 8px;
}

.footer-contact {
  list-style: none;
  padding: 0;
}

.footer-contact li {
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
}

.footer-social-links {
  display: flex;
  gap: 1rem;
}

.footer-social-link {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.footer-social-link:hover {
  background: white;
  color: #2c5aa0;
  transform: translateY(-5px);
}

/* ========================================================================= */
/* SCROLL BUTTON */
/* ========================================================================= */
.scroll-top-btn {
  position: fixed;
  bottom: 35px;
  right: 35px;
  width: 55px;
  height: 55px;
  background: linear-gradient(135deg, #2c5aa0 0%, #4a90e2 100%);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(44, 90, 160, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  font-size: 1.8rem;
}

.scroll-top-btn:hover {
  transform: translateY(-8px) scale(1.1);
  box-shadow: 0 15px 40px rgba(44, 90, 160, 0.6);
}

/* ========================================================================= */
/* ANIMATIONS */
/* ========================================================================= */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.animate-on-scroll.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* ========================================================================= */
/* RESPONSIVE */
/* ========================================================================= */
@media (max-width: 992px) {
  .contact-form {
    padding: 2rem;
  }

  .inquiry-types {
    grid-template-columns: repeat(3, 1fr);
  }

  .faq-teaser {
    flex-direction: column;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .page-header {
    padding-top: 100px;
  }

  .page-header h1 {
    font-size: 2.5rem;
  }

  .inquiry-types {
    grid-template-columns: repeat(2, 1fr);
  }

  .contact-info-card {
    margin-top: 2rem;
  }

  .complaint-steps .cs-step:hover {
    transform: none;
  }
}

@media (max-width: 576px) {
  .inquiry-types {
    grid-template-columns: 1fr 1fr;
  }

  .quick-contact-card {
    padding: 1.5rem;
  }
}
</style>